import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import EdrNoticeAdmin from './EdrNoticeAdmin';
import EdrReportAdmin from './EdrReportAdmin';
import EdrLicenseAdmin from './EdrLicenseAdmin';
import './EdrManagementSection.css';

/**
 * 관리자 페이지 > EDR — 3개 탭의 분기점.
 *
 * 탭별로 컴포넌트를 조건부 렌더한다. 세 탭을 한 번에 마운트하면 진입 시
 * 세 탭의 API가 모두 호출되어 첫 화면이 느려진다.
 *
 * REVIEWER 판정은 여기서 한 번만 한다 — 각 탭이 `useAuth`를 따로 읽으면
 * 한 곳에서 role 체크를 빠뜨리기 쉽다.
 */
const EdrManagementSection: React.FC<{ activeTab?: string }> = ({ activeTab = 'edr-html' }) => {
  const { user } = useAuth();
  const isReviewer = user?.role === 'reviewer';

  return (
    <div className="edr-admin-section">
      {activeTab === 'edr-html' && <EdrNoticeAdmin isReviewer={isReviewer} />}
      {activeTab === 'edr-report' && <EdrReportAdmin isReviewer={isReviewer} />}
      {activeTab === 'edr-license' && <EdrLicenseAdmin isReviewer={isReviewer} />}
    </div>
  );
};

export default EdrManagementSection;
